import { UserForm } from '@/pages/customer/profile'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: AuthState = {} as AuthState

const authSlice = createSlice({
	name: 'auth',
	initialState: initialState,
	reducers: {
		login(_state, action: PayloadAction<AuthState>) {
			return action.payload
		},
		updateUser(state, action: PayloadAction<UserForm>) {
			return { ...state, ...action.payload }
		},
		updateCounter(state, action: PayloadAction<AuthState['invoice_counter']>) {
			return { ...state, invoice_counter: action.payload }
		},
		logout() {
			return initialState
		},
	},
})

const { reducer } = authSlice

export const { login, updateUser, updateCounter, logout } = authSlice.actions

export default reducer
